import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
interface HeroProps {
  cartLink: string;
}
export const Hero: React.FC<HeroProps> = ({
  cartLink
}) => {
  return <section className="bg-brand-rose py-12 md:py-20 px-4 overflow-hidden" data-id="element-104">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-105">
        {/* Left Column: Copy & CTA */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col gap-6" data-id="element-106">
          <div className="inline-flex items-center gap-2 bg-brand-blush text-brand-wine px-4 py-1.5 rounded-full w-fit text-sm font-semibold" data-id="element-107">
            <span className="w-2 h-2 rounded-full bg-brand-wine animate-pulse" data-id="element-108"></span>
            +1578 Descargas
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-brand-charcoal" data-id="element-109">
            Dejar de Sobrepensar y Convertirte en la Mujer Que Él Persigue
          </h1>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-110">
            Presentando La Guía Definitiva Para cambiar la dinámica emocional a
            tu favor.
          </p>

          {/* Trust Rating */}
          <div className="flex items-center gap-3" data-id="element-111">
            <div className="flex text-brand-gold" data-id="element-112">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-113" />)}
            </div>
            <span className="text-sm font-medium text-gray-600 flex items-center gap-1" data-id="element-114">
              4.9/5 <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-115" /> Compras
              Verificadas
            </span>
          </div>

          {/* Price Block */}
          <div className="bg-white/60 backdrop-blur-sm p-6 rounded-2xl border border-brand-blush mt-4" data-id="element-116">
            <div className="flex flex-col gap-1 mb-4" data-id="element-117">
              <span className="text-gray-500 font-medium" data-id="element-118">
                Antes: <PriceDisplay basePriceARS={40000} strikeThrough data-id="element-119" />
              </span>
              <div className="flex items-baseline gap-3" data-id="element-120">
                <span className="text-lg font-bold text-brand-wine" data-id="element-121">HOY:</span>
                <PriceDisplay basePriceARS={25990} className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-122" />
              </div>
            </div>

            <CTAButton href={cartLink} fullWidth data-id="element-123">
              Obtener Acceso Instantáneo Ahora
            </CTAButton>

            <p className="text-xs text-center text-gray-500 mt-3 flex items-center justify-center gap-1" data-id="element-124">
              <ShieldCheck className="w-3 h-3" data-id="element-125" /> Pago único. Acceso inmediato.
            </p>
          </div>
        </motion.div>

        {/* Right Column: Video Placeholder */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-126">
          <div className="aspect-[4/5] md:aspect-square rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/p6xFMEiLhwcn1H7oqAHo4q/IMAGEN_1.jpg" alt="Mujer observando a hombre distraído con el teléfono" className="w-full h-full object-cover" data-id="element-128" />
          </div>

          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-gold/20 rounded-full blur-3xl -z-10" data-id="element-129" />
          <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-wine/10 rounded-full blur-3xl -z-10" data-id="element-130" />
        </motion.div>
      </div>
    </section>;
};